import { Card, Button, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { useDispatch, useSelector } from "react-redux";
import { loadDepartments, loadReportingManagers, loadTeams } from '../../../../redux/actions/lookups.action';
import { PeriodList } from '../../../../utils/PeriodList';
import Select from 'react-select';


function Filter(props) {
    var isUserLogged = localStorage.getItem('argus_user') !== null ? JSON.parse(localStorage.getItem('argus_user')) : "";

    const dispatch = useDispatch();
    const [keyword, setKeyword] = useState("");
    const [departmentList, setDepartmentList] = useState([]);
    const [teamList, setTeamList] = useState([]);

    const [selectedDept, setSelectedDept] = useState(null);
    const [selectedTeam, setSelectedTeam] = useState(null);
    const [selectedPeriod, setSelectedPeriod] = useState(null);

    let LUDepartment = useSelector(state => state.loadDepartment_Reducer.departmentList);
    let LUTeam = useSelector(state => state.loadTeam_Reducer.teamList);


    useEffect(() => {
        dispatch(loadDepartments());
        getCurrentSessionDetails();
    }, [])

    useEffect(() => {
        if (LUDepartment !== undefined) {
            setDepartmentList(LUDepartment)
        }
    }, [LUDepartment])

    useEffect(() => {
        if (LUTeam !== undefined) {
            setTeamList(LUTeam)
        }
    }, [LUTeam])

    function getCurrentSessionDetails() {
        const currentYear = new Date().getFullYear();
        const currentMonth = new Date().getMonth() + 1;
        var value = {
            lable: currentYear,
            value: currentYear
        }
       
        var list = PeriodList(3, "half",true);
console.log(list)
        const res = list.filter(list => parseInt(list.value) === parseInt(currentYear))[0];
        console.log(res)
        props.handleChangeYear(res.value);
        setSelectedPeriod(res);
    }

    const handleChangeKeyword = (e) => {
        setKeyword(e.target.value);
        props.handleChangeKeyword(e.target.value);
    }
    const handleChangePeriod = (obj) => {
        setSelectedPeriod(obj);
        props.handleChangeYear(obj.value);
        // props.handleChangeDateFilter(obj.value.split("-")[1]);
    };
    const handleChangeTeam = (obj) => {
        setSelectedTeam(obj);
        props.handleChangeTeamId(obj.value);
    };
    const handleChangeDepartment = (obj) => {
        setSelectedDept(obj);
        dispatch(loadTeams(parseInt(obj.value)));
        props.handleChangeDepartmentId(obj.value);

    }

    const clearAll = () => {
        // setSelectedPeriod(null);
        setSelectedTeam(null);
        setKeyword("");
        setSelectedDept(null);

        props.handleChangeKeyword("");
        props.handleChangeTeamId("");
        props.handleChangeDepartmentId("");
        // props.handleChangeYear("");
        props.handleChangeDateFilter("");
        props.loadTeamForm(1);
        getCurrentSessionDetails()
    }

    const handleFilter = () => {
        props.loadTeamForm();
    }

    return (
        <div className='filter' style={{ marginTop: "0px" }}>
            <h3 className='filters'>Filters</h3>
            <ValidatorForm onSubmit={() => handleFilter()}>
                <Grid container xs={12} spacing={2}>
                    <Grid item xs={3}>
                        <TextValidator className='custom-height-input' fullWidth placeholder='Search by name' value={keyword} onChange={handleChangeKeyword} />
                    </Grid>
                    <Grid item xs={3}>
                        <Select placeholder="Select Period" options={PeriodList(3, "half",true)} onChange={handleChangePeriod} value={selectedPeriod} />
                    </Grid>
                    {(isUserLogged.usertype === "Admin" || isUserLogged.usertype === "SuperAdmin" || isUserLogged.usertype === "HRManager" || isUserLogged.usertype === "HR") ?
                        <>
                            <Grid item xs={3}>
                                <Select placeholder="Select Department" options={departmentList} onChange={handleChangeDepartment} value={selectedDept} />
                            </Grid>
                            {selectedDept === null ? "" :
                                <Grid item xs={3}>
                                    <Select placeholder="Select Team" options={teamList} onChange={handleChangeTeam} value={selectedTeam} />
                                </Grid>}

                        </>
                        : <></>}
                    <Grid item xs={3} spacing={2} sx={{ display: "flex", justifyContent: "flex-end", margin: "0px 0 15px 0" }}>
                        {/* <Grid item xs={12}> */}
                        <Button className='theme-btn cancel-btn' variant="contained" onClick={() => clearAll()} >Clear</Button>&nbsp;&nbsp;
                        <Button className='theme-btn' sx={{ marginRight: "10px" }} type="submit" variant="contained">Search</Button>
                        {/* </Grid> */}
                    </Grid>
                </Grid>
            </ValidatorForm>
        </div>
    )
}
export default Filter;